import type { Me } from "@alm/api-contracts";
import {
  canAt,
  isFeatureEnabledAt,
  landingFor,
  visibleWorkspaces,
  WORKSPACE_BY_ID,
  type PolicySubject,
} from "@alm/policy";
import { chosenFacility } from "@/lib/facility/facility-choice";
import { navigationFor } from "@/lib/policy";
import { LENS_GATES } from "./lens-order";

/** Where somebody with no dashboard lens starts instead: a kitchen opens on Menus (Nancy's
 * workspace), not on an empty clinical dashboard. Null keeps the dashboard. UX only. */
export function landingInsteadOfDashboard(me: Me | null): string | null {
  if (!me) return null;
  const subject = me.subject as PolicySubject;
  if (!subject.organization) return null;
  const hasLens = Object.values(LENS_GATES).some(
    (gate) =>
      canAt(subject, gate.permission, null) &&
      (!gate.feature || isFeatureEnabledAt(subject, gate.feature, null)),
  );
  if (hasLens) return null;
  const navigation = navigationFor(subject, chosenFacility(subject));
  if (navigation.some((entry) => entry.id === "menu-planner")) return "/menus";
  const nancy = visibleWorkspaces(navigation).some((workspace) => workspace.id === "nancy");
  return nancy ? landingFor(WORKSPACE_BY_ID.nancy, navigation) : null;
}
